import {BrandSection} from './BrandSection'
import {CategorySection} from './CategorySection'

export const BrandAndCategoryTab = () => {
  return (
    <div className="grid grid-cols-2 items-start gap-3">
      <BrandSection />
      <CategorySection />
    </div>
  )
}
